export type SpaceInfo = {
	spaceKey: string | null | undefined;
	spaceId: string | null | undefined;
	spaceName: string | null | undefined;
};
export const NULL_SPACE_OBJECT: SpaceInfo = { spaceKey: null, spaceId: null, spaceName: null };
